export default __webpack_public_path__ + "locales/fi/DeleteDialog.json?hash=955efc88fac84b0d5138b6546d6e0a9b";